// キーボード操作の判定と表示をここにまとめてある。
// 変えたいときはこのファイルだけ触ればよい。

/**
 * Mac かどうか。
 * Windows と Linux は Ctrl、Mac は Cmd（⌘）を使う。
 */
export const isMac = () => {
  if (typeof navigator === 'undefined') return false;
  const s = `${navigator.platform || ''} ${navigator.userAgent || ''}`;
  return /Mac|iPhone|iPad|iPod/i.test(s);
};

/** 主のキー（Ctrl または Cmd）が押されているか */
export const hasMainKey = (e) => (isMac() ? e.metaKey : e.ctrlKey);

/** 画面に出すときの文字 */
export const MAIN_KEY_LABEL = isMac() ? '⌘' : 'Ctrl';

/**
 * どの操作にあたるかを返す。
 *   'focusAdd'    … タスク追加欄へ移動（Ctrl/Cmd + J）
 *   'focusRunning' … 実行中のタスク名欄へ移動（Ctrl/Cmd + K）
 *   'start'       … すぐ開始（Shift + Enter）
 *   'toggle'      … 実行中を完了 / 無ければ予定の先頭を開始（Ctrl/Cmd + Shift + Enter）
 *   'add'         … タスク追加（Ctrl/Cmd + Enter）
 *   null          … どれでもない
 *
 * Enter 単体は何も返さない。日本語の変換を確定したときに
 * 続けて Enter を押してしまい、意図せず追加されるのを防ぐため。
 */
export const shortcutOf = (e) => {
  const main = hasMainKey(e);

  if (e.key === 'Enter') {
    // 日本語などの変換中は無視する
    if (e.isComposing || e.keyCode === 229) return null;
    if (main && e.shiftKey) return 'toggle';
    if (main) return 'add';
    if (e.shiftKey) return 'start';
    return null;
  }

  if (main && (e.key === 'j' || e.key === 'J')) return 'focusAdd';
  if (main && (e.key === 'k' || e.key === 'K')) return 'focusRunning';

  return null;
};

/** 案内に出す一覧。設定画面で使う */
export const SHORTCUTS = [
  { keys: [MAIN_KEY_LABEL, 'K'], text: '実行中のタスク名の入力欄へ移動する' },
  { keys: [MAIN_KEY_LABEL, 'J'], text: 'タスク追加のタスク名の入力欄へ移動する' },
  { keys: ['Shift', 'Enter'], text: 'いま開始する（割り込み）' },
  {
    keys: [MAIN_KEY_LABEL, 'Shift', 'Enter'],
    text: '実行中のタスクを完了する。実行中がなければ、予定の先頭を開始する',
  },
  { keys: ['Esc'], text: '入力中の内容を消す' },
  { keys: ['Tab'], text: '次の入力欄へ移る（Shift + Tab で戻る）' },
];
